import { isAxiosError } from 'axios'

import { ApproverListDeniedReason } from '@ankor-io/common/types/approval-workflows/types'

/**
 * True when the expense list was refused because this approver sits on no workflow stage.
 * HTTP `info` is the backend `clientInfo`: `{ reason }`.
 *
 * @example
 * ```ts
 * if (isApproverNotOnWorkflowError(error)) {
 *   // show the ask-an-operator empty state
 * }
 * ```
 */
export function isApproverNotOnWorkflowError(error: unknown): boolean {
  if (!isAxiosError<{ info?: { reason?: string } }>(error) || error.response?.status !== 403) {
    return false
  }

  return error.response.data?.info?.reason === ApproverListDeniedReason.NOT_ON_WORKFLOW
}
